import { type StockData, type StockEntry } from "~/utils/cartUpdating/delivery/stockDataTypes";

export function isStock(stockData: StockEntry) {
  return stockData.type === "stock";
}

export function isProduction(stockData: StockEntry) {
  return stockData.type === "production";
}

export function isReplenishment(stockData: StockEntry) {
  return stockData.type === "replenishment";
}

export function getPhysicalDeliveries(stockData: StockData) {
  return stockData.filter((entry) => !isReplenishment(entry));
}
